import { useSelector, useDispatch } from "react-redux";
import { IReduxState } from "src/reduxTypes";
import { loginActions } from "src/modules/Auth/store/actions";
import { useHistory } from "react-router";
import { IAuth } from "src/modules/Auth/store/types";

interface IActions {
  logout: () => void
  refreshSession: () => void
}

export const useAuth = (): [IAuth, IActions] => {
  const history = useHistory();
  const dispatch = useDispatch()
  const auth = useSelector((reduxState: IReduxState): IAuth => ({
    username: reduxState.auth.username,
    refreshToken: reduxState.auth.refreshToken,
    userType: reduxState.auth.userType,
    idToken: reduxState.auth.idToken,
    accessToken: reduxState.auth.accessToken,
    termsOfUseStatus: reduxState.auth.termsOfUseStatus
  }));
  const refreshSession = () => dispatch(loginActions.refreshLogIn(auth.refreshToken))
  const logout = () => dispatch(loginActions.logout(history))
  return [auth, { logout, refreshSession }]
}